export const newsList = [
  {
    id: "n1",
    title: "《山海之约》票房破十亿，东方奇幻再掀观影热潮",
    category: "电影新闻",
    publishTime: "2024-10-08 09:30",
    author: "蜜桃影讯",
    summary:
      "上映三周，《山海之约》累计票房正式突破十亿，成为今年暑期档后表现最亮眼的国产奇幻片。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20news%20still%20of%20a%20misty%20peach%20tree%20valley%20at%20sunrise%20with%20warm%20golden%20light%2C%20elegant%20editorial%20photography%2C%20atmospheric%20depth%2C%20high%20detail%2C%20no%20text&width=1200&height=800&seq=peach-news-c1&orientation=landscape",
    relatedMediaId: "m1",
    content: [
      "据片方公布的数据，截至本周，《山海之约》累计票房正式突破十亿，观影人次超过两千万，成为今年暑期档之后表现最亮眼的国产奇幻电影。",
      "影片自上映以来口碑持续走高，其将东方奇幻世界观与细腻情感结合的叙事方式，获得了不少观众的认可。社交平台上，关于影片美术与配乐的讨论热度居高不下。",
      "导演沈知远在接受采访时表示，团队在筹备阶段走访了多处自然景观，希望让画面既恢弘又温暖。他透露，续集的剧本已在打磨之中，但短期内不会急于推进。",
      "业内人士认为，随着制作水准的提升，东方奇幻题材正在获得更广泛的观众基础，后续或将有更多同类作品进入市场。",
    ],
  },
  {
    id: "n2",
    title: "《王座之影》第四季杀青，主创剧透终极对决",
    category: "电视剧新闻",
    publishTime: "2024-10-06 14:10",
    author: "剧集观察",
    summary:
      "备受关注的史诗剧集《王座之影》第四季正式杀青，主创团队在线上发布会分享了新一季的看点。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20news%20still%20of%20a%20medieval%20torch%20lit%20hall%20interior%20with%20banners%2C%20epic%20drama%20atmosphere%2C%20warm%20ember%20lighting%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=1200&height=800&seq=peach-news-c2&orientation=landscape",
    relatedMediaId: "t4",
    content: [
      "史诗剧集《王座之影》第四季已于近日正式杀青，制作周期历时近十个月。主创团队在线上发布会上透露，新一季将迎来此前埋下的多条线索的集中回收。",
      "制片人表示，第四季在保持宏大场面的同时，会更注重人物之间的情感张力，「我们希望观众看到的不只是权力斗争，还有人如何在其中做出选择」。",
      "主演们也在发布会上分享了拍摄花絮，包括为动作场面进行的长期训练，以及在高强度拍摄中建立的默契。",
      "剧集预计将于明年上线，官方暂未公布具体档期，但表示预告片将在近期发布。",
    ],
  },
  {
    id: "n3",
    title: "2024 贺岁档前瞻：多部国产大片集结待映",
    category: "行业动态",
    publishTime: "2024-10-04 11:00",
    author: "行业观察室",
    summary:
      "随着年末临近，多部国产大片陆续定档，题材涵盖历史、科幻与现实题材，市场期待值持续攀升。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20news%20still%20of%20a%20modern%20cinema%20marquee%20glowing%20at%20dusk%20with%20warm%20lights%2C%20editorial%20photography%2C%20clean%20composition%2C%20high%20detail%2C%20no%20text&width=1200&height=800&seq=peach-news-c3&orientation=landscape",
    relatedMediaId: "t12",
    content: [
      "进入第四季度，贺岁档的排片逐渐明朗。据不完全统计，已有超过十部国产影片确定档期，题材覆盖历史、科幻、现实与家庭等方向。",
      "业内分析认为，观众对内容质量的要求持续提高，单纯依靠明星阵容已不足以支撑票房，扎实的剧本与制作水准成为关键。",
      "与此同时，多部剧集也在年末档期集中上线，线上与线下内容的竞争进一步加剧，用户的选择更加丰富。",
      "有从业者表示，良性竞争有助于推动行业整体水准提升，也让优质内容获得更多被看见的机会。",
    ],
  },
  {
    id: "n4",
    title: "《深蓝回响》释出全新预告，悬疑氛围拉满",
    category: "电影新闻",
    publishTime: "2024-09-30 16:45",
    author: "蜜桃影讯",
    summary:
      "科幻悬疑电影《深蓝回响》发布全新预告片，幽暗深海与未知信号的设定引发观众强烈好奇。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20news%20still%20of%20a%20deep%20sea%20observation%20window%20glowing%20in%20darkness%2C%20moody%20sci%20fi%20atmosphere%2C%20cool%20tones%20with%20warm%20accents%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=1200&height=800&seq=peach-news-c4&orientation=landscape",
    relatedMediaId: "m4",
    content: [
      "科幻悬疑电影《深蓝回响》近日发布全新预告片，短短两分钟的画面中，幽暗的深海与反复出现的未知信号成为最大看点。",
      "预告片以大量环境音与克制的对话营造压迫感，主角独自潜入海沟的片段尤其令人印象深刻。",
      "导演程确表示，影片试图探讨的不是「外面有什么」，而是「我们愿意相信什么」，希望观众在紧张之余也能有所思考。",
      "影片已于近期上映，相关讨论仍在持续发酵。",
    ],
  },
  {
    id: "n5",
    title: "《长安食肆》第二季官宣，原班人马回归",
    category: "电视剧新闻",
    publishTime: "2024-09-26 10:20",
    author: "剧集观察",
    summary:
      "美食古装剧《长安食肆》确认开发第二季，主创与原班演员将悉数回归，故事将走出长安城。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20news%20still%20of%20an%20ancient%20Chinese%20night%20food%20street%20with%20warm%20lanterns%20and%20steam%2C%20festive%20atmosphere%2C%20warm%20palette%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=1200&height=800&seq=peach-news-c5&orientation=landscape",
    relatedMediaId: "t1",
    content: [
      "凭借温暖治愈的风格，《长安食肆》自上线以来收获了不少观众喜爱。官方近日正式宣布第二季立项，主创团队与原班演员将悉数回归。",
      "据透露，第二季的故事将不再局限于长安城，食肆的招牌会随着主角的脚步走向更远的地方，也会遇见更多有意思的客人。",
      "编剧表示，美食始终是串起故事的线索，但真正想讲的还是人与人之间的羁绊。",
      "第二季预计于明年开拍，具体上线时间待定。",
    ],
  },
  {
    id: "n6",
    title: "流媒体加码自制内容，行业格局持续演变",
    category: "行业动态",
    publishTime: "2024-09-22 09:00",
    author: "行业观察室",
    summary:
      "各大流媒体平台持续加大对自制剧集与电影的投入，内容供给结构正在发生明显变化。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20news%20still%20of%20modern%20streaming%20studio%20with%20screens%20and%20editing%20desks%20glowing%2C%20clean%20warm%20lighting%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=1200&height=800&seq=peach-news-c6&orientation=landscape",
    relatedMediaId: "t6",
    content: [
      "过去一年，各大流媒体平台相继公布自制内容计划，从悬疑、科幻到现实题材，投入规模与题材广度都在提升。",
      "分析认为，自制内容能够帮助平台建立差异化优势，也更容易形成稳定的用户粘性，因此成为竞争的核心战场。",
      "与此同时，制作周期长、成本高的问题也不容忽视。如何在数量与质量之间取得平衡，是每个平台都需要面对的课题。",
      "对观众而言，内容供给的丰富意味着更多的选择，但也对挑选与推荐提出了更高要求。",
    ],
  },
  {
    id: "n7",
    title: "《霓虹追踪》导演确认开发续集，剧本已启动",
    category: "电影新闻",
    publishTime: "2024-09-18 15:30",
    author: "蜜桃影讯",
    summary:
      "犯罪动作片《霓虹追踪》导演确认续集已在开发中，主角的故事将回到更早的时间线。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20news%20still%20of%20a%20neon%20lit%20city%20street%20at%20night%20with%20wet%20reflections%2C%20moody%20thriller%20atmosphere%2C%20warm%20and%20cool%20contrast%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=1200&height=800&seq=peach-news-c7&orientation=landscape",
    relatedMediaId: "m2",
    content: [
      "在近期的一次访谈中，《霓虹追踪》导演确认续集已进入开发阶段，剧本正在打磨。",
      "他表示，续集不会简单地重复前作，而是会把时间线往前推移，讲述主角在成为警探之前的一段经历。",
      "「我们想回答的是，一个人是怎么变成现在的样子的。」导演这样解释续集的方向。",
      "影片的具体开机时间尚未公布，但制作方透露团队已开始进行前期勘景。",
    ],
  },
  {
    id: "n8",
    title: "《晨昏之间》结局引热议，编剧回应观众疑问",
    category: "电视剧新闻",
    publishTime: "2024-09-14 20:05",
    author: "剧集观察",
    summary:
      "医疗爱情剧《晨昏之间》迎来收官，开放式结局在社交平台引发广泛讨论，编剧发文回应。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20news%20still%20of%20a%20hospital%20corridor%20at%20dawn%20with%20soft%20warm%20light%20through%20windows%2C%20calm%20atmosphere%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=1200&height=800&seq=peach-news-c8&orientation=landscape",
    relatedMediaId: "t3",
    content: [
      "《晨昏之间》近日迎来收官，两位主角在晨光中并肩走向走廊尽头的开放式结局，引发观众热烈讨论。",
      "有观众认为结局留白过多，也有人表示这样的处理恰恰呼应了剧集「陪伴」的主题。",
      "编剧随后发文回应，称结局并非刻意回避，而是希望把想象的空间留给观众，「他们的故事还在继续，只是我们不再打扰」。",
      "剧集相关话题在播出后持续登上热搜，讨论热度居高不下。",
    ],
  },
  {
    id: "n9",
    title: "电影修复技术升级，多部经典老片陆续重映",
    category: "行业动态",
    publishTime: "2024-09-10 13:15",
    author: "行业观察室",
    summary:
      "随着修复技术的发展，多部经典影片以全新面貌重返银幕，唤起观众的集体记忆。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20news%20still%20of%20classic%20film%20reels%20and%20restoration%20equipment%20in%20warm%20light%2C%20nostalgic%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=1200&height=800&seq=peach-news-c9&orientation=landscape",
    relatedMediaId: "m6",
    content: [
      "近年来，数字修复技术不断进步，让许多年代久远的影片得以以更清晰的画质重现。",
      "多家机构陆续推出经典影片的修复版重映计划，涵盖剧情、纪录与动画等多种类型，吸引了不少年轻观众走进影院。",
      "修复团队介绍，一部影片的修复往往需要数月甚至更长时间，需要逐帧处理画面与声音。",
      "业内人士认为，经典影片的重映不仅是对历史的保存，也让不同年代的观众得以共享同一份感动。",
    ],
  },
  {
    id: "n10",
    title: "《星际摆渡人》入围国际奇幻电影节主竞赛",
    category: "电影新闻",
    publishTime: "2024-09-06 08:40",
    author: "蜜桃影讯",
    summary:
      "科幻冒险电影《星际摆渡人》确认入围某国际奇幻电影节主竞赛单元，将参与多项奖项角逐。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20news%20still%20of%20a%20colorful%20nebula%20with%20a%20small%20spacecraft%2C%20epic%20sci%20fi%20atmosphere%2C%20warm%20starlight%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=1200&height=800&seq=peach-news-c10&orientation=landscape",
    relatedMediaId: "m8",
    content: [
      "科幻冒险电影《星际摆渡人》确认入围某国际奇幻电影节主竞赛单元，将在电影节期间进行多场展映。",
      "影片以宏大的星际景观与克制的情感叙事获得选片方关注，被认为在类型表达上做出了新的尝试。",
      "导演表示，能够入围是对团队工作的肯定，也期待影片能与更多不同文化背景的观众见面。",
      "电影节获奖名单将于下月公布，影片将参与包括最佳影片在内的多个奖项角逐。",
    ],
  },
  {
    id: "n11",
    title: "《小巷人家》收官口碑走高，年代剧回暖信号明显",
    category: "电视剧新闻",
    publishTime: "2024-09-02 17:50",
    author: "剧集观察",
    summary:
      "年代家庭剧《小巷人家》收官，凭借真实细腻的叙事获得高口碑，也让年代题材再度受到关注。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20news%20still%20of%20an%20old%20alley%20neighborhood%20in%20warm%20afternoon%20light%20with%20bicycles%2C%20nostalgic%20atmosphere%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=1200&height=800&seq=peach-news-c11&orientation=landscape",
    relatedMediaId: "t5",
    content: [
      "年代家庭剧《小巷人家》近日收官，凭借真实的生活质感与细腻的人物刻画，收获了不俗的口碑。",
      "剧中关于邻里互助与家庭日常的片段被观众反复讨论，不少人表示在小巷里看到了自己童年的影子。",
      "有评论认为，年代剧的回暖说明观众对贴近生活、情感真挚的故事始终有需求。",
      "制作方表示，未来会继续在现实题材上进行更多探索。",
    ],
  },
  {
    id: "n12",
    title: "影视工业化提速，虚拟拍摄成为新趋势",
    category: "行业动态",
    publishTime: "2024-08-28 10:35",
    author: "行业观察室",
    summary:
      "随着虚拟拍摄技术逐渐成熟，越来越多的剧组开始尝试以数字化方式呈现复杂场景。",
    image:
      "https://readdy.ai/api/search-image?query=Cinematic%20news%20still%20of%20a%20virtual%20film%20set%20with%20large%20LED%20wall%20and%20crew%20silhouettes%2C%20modern%20production%20atmosphere%2C%20editorial%20photography%2C%20high%20detail%2C%20no%20text&width=1200&height=800&seq=peach-news-c12&orientation=landscape",
    relatedMediaId: "m12",
    content: [
      "虚拟拍摄正被越来越多剧组采用。通过大尺寸 LED 屏与实时渲染技术，制作团队可以在棚内完成此前需要实地取景的复杂场景。",
      "技术人员介绍，这种方式不仅能够降低成本，还能让演员在更直观的环境中表演，提升画面的真实感。",
      "不过，虚拟拍摄对前期筹备与团队协作提出了更高要求，并非所有项目都适合。",
      "业内普遍认为，随着技术普及与经验积累，影视工业化水平有望进一步提升。",
    ],
  },
];